import useServiceFactory from "../serviceFactory";

const apiUrl = "/administracion/solicitudVacantes";

const useApiCapacitacion= () => {
    const service = useServiceFactory({uri: process.env.REACT_APP_API_URL});
    return {
        filtrar: async (params) => service.get(`${apiUrl}`, {params, showLoading: true}), 
        obtener: async (id) => service.get(`${apiUrl}/${id}`, { showLoading: true }),     
        guardar: async (formData) => service.post(`${apiUrl}`, formData),
        cerrar: async (id,formData) => service.put(`${apiUrl}/${id}/cerrarSolicitudVacantes`,formData),
        cancelar: async (id,formData) => service.put(`${apiUrl}/${id}/cancelarSolicitudVacantes`,formData),
        aceptar: async (id) => service.put(`${apiUrl}/${id}/aceptarSolicitudVacantes`),
        entrevista: async (id,formData) => service.put(`${apiUrl}/${id}/entrevistaSolicitudVacantes`,formData),
        excel: async (params) => service.get(`${apiUrl}/excel`,
            {
                params,
                showLoading: true,
                download: true,
                fileName: `SolciitudVacantes.xlsx`
            }),
    };
};

export default useApiCapacitacion;
